// Simple pub-sub store so axios interceptors (outside React tree)
// can control a loader that Layout (inside React tree) subscribes to.

let activeRequests = 0;
let listeners = [];

const notify = () => {
  listeners.forEach((listener) => listener(activeRequests > 0));
};

export const loaderStore = {
  subscribe(listener) {
    listeners.push(listener);
    return () => {
      listeners = listeners.filter((l) => l !== listener);
    };
  },
  start() {
    activeRequests += 1;
    notify();
  },
  stop() {
    activeRequests = Math.max(0, activeRequests - 1);
    notify();
  },
  getIsLoading() {
    return activeRequests > 0;
  },
};